import { gql } from '@apollo/client';

export const SmartSearchQueryName = 'SmartSearch';

export const SMART_SEARCH_QUERY = gql`
  query ${SmartSearchQueryName}($query: String!) {
    smartSearch(query: $query) {
      id
      type
      label
      detail
      longitude
      latitude
      bounds
      geometry
      score
    }
  }
`;
